exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example[data-v-251c867b]{margin-bottom:20px;color:#5e5e5e;font-size:12px;ul{padding-left:20px;li{padding-right:20px}}}.upload-btn[data-v-251c867b]{margin:0 auto;width:50%;justify-content:center}.close-modal-text[data-v-251c867b]{display:flex;justify-content:center;align-items:center;margin:5em 0;font-size:18px}", ""]);

// exports
